// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"f5ff2805","585":"f5ff2805","766":"f5ff2805","877":"c995966f","933":"6ef7bb1a"}[chunkId] + ".chunk.css";
};